<div class="section-heading">

  <div>

    <span class="section-kicker">
      Dashboard
    </span>

    <h2>
      Welcome back
    </h2>

    <p>
      Choose an area below to update the
      Holowicki website.
    </p>

  </div>

</div>


<div class="stats-grid">

  <article class="stat-card">

    <span class="stat-label">
      Store locations
    </span>

    <strong>
      @if (locationsLoading) {
        —
      } @else {
        {{ locationsCount }}
      }
    </strong>

    <button
      type="button"
      (click)="selectSection('locations')"
    >
      Manage locations
    </button>

  </article>


  <article class="stat-card">

    <span class="stat-label">
      Community posts
    </span>

    <strong>
      @if (communityLoading) {
        —
      } @else {
        {{ communityPostsCount }}
      }
    </strong>

    <button
      type="button"
      (click)="selectSection('community')"
    >
      Manage posts
    </button>

  </article>


  <article class="stat-card">

    <span class="stat-label">
      Staff profiles
    </span>

    <strong>
      @if (staffLoading) {
        —
      } @else {
        {{ staffMembersCount }}
      }
    </strong>

    <button
      type="button"
      (click)="selectSection('staff')"
    >
      Manage staff
    </button>

  </article>

</div>


<div class="panel quick-panel">

  <div class="panel-heading">

    <div>

      <span class="section-kicker">
        Quick actions
      </span>

      <h3>
        What would you like to update?
      </h3>

    </div>

  </div>


  <div class="quick-grid">

    <button
      type="button"
      class="quick-action yellow"
      (click)="selectSection('community')"
    >

      <span class="action-symbol">
        ＋
      </span>

      <strong>
        New community post
      </strong>

      <small>
        Share an event, fundraiser or local story
      </small>

    </button>


    <button
      type="button"
      class="quick-action"
      (click)="selectSection('locations')"
    >

      <span class="action-symbol">
        ＋
      </span>

      <strong>
        Add a location
      </strong>

      <small>
        Add its contact information and weekly hours
      </small>

    </button>


    <button
      type="button"
      class="quick-action"
      (click)="selectSection('staff')"
    >

      <span class="action-symbol">
        ＋
      </span>

      <strong>
        Add staff member
      </strong>

      <small>
        Create a new public-facing staff profile
      </small>

    </button>


    <button
      type="button"
      class="quick-action"
      (click)="selectSection('youtube')"
    >

      <span class="action-symbol play">
        ▶
      </span>

      <strong>
        Change featured video
      </strong>

      <small>
        Paste and preview a standard YouTube link
      </small>

    </button>

  </div>

</div>